export { default } from './NotificationDetails'
export * as S from './NotificationDetails.styles'
